import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { NetworkSpeedService } from '../../services/network-speed-service.service';
@Component({
  selector: 'app-network-status',
  standalone: true,
  imports: [],
  templateUrl: './network-status.component.html',
  styleUrl: './network-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkStatusComponent implements OnInit {
  networkStatus: string = 'online';
  ShowNetworkMessage: boolean = false;

  constructor(
    private networkSpeedService: NetworkSpeedService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.networkSpeedService.networkSpeed$.subscribe((status) => {
      this.networkStatus = status;
      this.cd.markForCheck();
    });
  }
}
